export default "__VITE_ASSET__BxCw0UHJ__"